import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaUserPlus } from "react-icons/fa6";

const Navbar = () => {
  const location = useLocation();

  // Unified navigation path mapping setup
  const navItems = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Gallery", path: "/gallery" },
    { name: "Vlog", path: "/vlog" },
    { name: "Admin", path: "/login" },
  ];

  // Logic to determine active routes matching your app structure
  const isActive = (path) =>
    path === "/"
      ? location.pathname === "/"
      : location.pathname.startsWith(path);

  return (
    <div className="sticky top-0 z-50 backdrop-blur-md  transition-all duration-300">
      <div className="navbar max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16">
        {/* Left Side - Logo & Mobile Hamburger Menu */}
        <div className="navbar-start">
          <div className="dropdown">
            <div
              tabIndex={0}
              role="button"
              className="btn btn-ghost lg:hidden p-1 mr-2 text-green-950 hover:bg-stone-100 rounded-xl"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </div>

            {/* Mobile Dropdown Overlay Popover menu */}
            <ul
              tabIndex={0}
              className="menu menu-md dropdown-content mt-3 z-[1] p-3 shadow-xl bg-white border border-stone-100 rounded-2xl w-56 gap-1"
            >
              {navItems.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    className={`px-4 py-2.5 rounded-xl font-semibold transition-all text-sm ${
                      isActive(item.path)
                        ? "bg-emerald-50 text-emerald-950 font-bold"
                        : "text-stone-600 hover:bg-stone-50 hover:text-green-900"
                    }`}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Brand Logo Platform Link */}
          <Link
            to="/"
            className="text-base sm:text-lg font-black tracking-tight text-green-950 hover:opacity-80 transition-opacity"
          >
            Mohammodia Baria Jam E Masjid
          </Link>
        </div>

        {/* Center Side - Inline Horizontal Desktop Menu */}
        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal px-1 gap-1.5">
            {navItems.map((item) => (
              <li key={item.name}>
                <Link
                  to={item.path}
                  className={`px-4 py-2 rounded-xl text-sm font-bold tracking-wide transition-all duration-200 ${
                    isActive(item.path)
                      ? "bg-emerald-50 text-emerald-950 shadow-sm shadow-emerald-100/50"
                      : "text-stone-600 hover:text-emerald-900 hover:bg-stone-50"
                  }`}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Side - Premium Action Membership Trigger */}
        <div className="navbar-end">
          <Link
            to="/membership"
            className="inline-flex items-center gap-2 px-4 py-2 bg-green-950 text-white font-medium rounded-full hover:bg-green-800 transition-all duration-300 transform hover:-translate-y-0.5 shadow-sm hover:shadow-md text-xs sm:text-sm"
          >
            <FaUserPlus className="w-3.5 h-3.5 opacity-90" />
            <span>Be A Member</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
